import React,{useState,useEffect} from 'react';
import { Singleton } from '../../js/Singleton';
import TimerCountDown from './Others/TimerCountDown';
import { SearchSelectionAgent, AgentButton, useTimerDownUp } from 'global-components-library';
import SelectReprogramPhone from './Others/SelectReprogramPhone';
import DatePicker from './Others/DatePicker';
import { SingletonSharedData } from '../../js/singletonSharedData';
import { APIFactory } from 'cw-galatea-api-js/cw-galatea-api-js-bundle';
import { useDispatch, useSelector } from 'react-redux';
import { actionPreviewRecord } from '../../redux/actions/A_messages_to_SM';
import { incrementDiscardedRegisters, removeRecord } from '../../redux/actions/A_preview';
import A_Alert_Modal from '../../redux/actions/A_Alert_Modal';
import { RECORD_STATE } from '../../constants';

const language = new Singleton();
const sharedData = new SingletonSharedData();
const  APIFact = new APIFactory();
const apiCont = APIFact.buildClient();
const { hideAlertModal } = A_Alert_Modal.creators;

const Dispositions = ({ type,onChangeDisp, endWraUpWithoutDisp, endWraUpWithDisp, onChangeReprogam, rateInDialog=false}) => {
  const {records, fReplacementJob, ndScheduled ,selectedRecord: { 
    wrapUpTime,
    callOutId,
    camId,
    phoneToCall,
    initPreviewTime,
    status
   } } = useSelector(state => state.preview);
  const [response, setResponse] = useState({dispositionError:null, dispositionList:null});
  const [dispositionSelected, setDispositionSelected] = useState(null);
  const [subDisposition, setSubDisposition] = useState(null);
  const [showDisposition, setShowDisposition] = useState(false)
  const [showSubDisposition, setShowSubDisposition] = useState(false);
  const [showCanReprogram, setShowCanReprogram] = useState(false);
  const [disableBtnSave,setDisableBtnSave] = useState(true);
  const [withDisposition, setWithDisposition] = useState(false);
  const [phoneReprogram,setPhoneReprogram] = useState("");
  const [dateReprogram,setDateReprogram] = useState("");
	const {  timeLeft, startTimer, stopTimer } = useTimerDownUp({ secondsInitial: wrapUpTime  });


  const dispatch = useDispatch();


  useEffect(() => {
      let dataSend= {
          CallOutId: callOutId,
          Id: camId,
          Type: type,
          UserId: sharedData.getParameters().UserID,
          CamId: camId
        };
      getDisposition(dataSend);
  }, []);

  useEffect(() => { 
  if(phoneReprogram!=="" || dateReprogram !== ""){
    onChangeReprogam({phoneReprogram: phoneReprogram, dateReprogram: dateReprogram})
  }
  }, [phoneReprogram,dateReprogram])
  

  useEffect(() => {
    if(dispositionSelected != null )
    {
      Object.keys(dispositionSelected.SubDisposition).length > 0 ? setShowSubDisposition(true) : setShowSubDisposition(false);
      let canReprogam=dispositionSelected.CanReprogram || (subDisposition != null && subDisposition.CanReprogram);
      setShowCanReprogram(canReprogam);
      onChangeDisp({dispositionSelected:dispositionSelected,canReprogram:canReprogam, subDispositionSelected:subDisposition !== null ? subDisposition.Id : 0});
    }
  }, [dispositionSelected, subDisposition])

    useEffect(() => {
      if(showCanReprogram)
      {
        if(phoneReprogram !== "" && dateReprogram !== ""){
          setDisableBtnSave(false)
        }
        else
        setDisableBtnSave(true)
      }
    }, [showCanReprogram,phoneReprogram,dateReprogram])
  useEffect(() => {
    if(status !== RECORD_STATE.WAITING_WRAPUP)
    {
      startTimer()
    }
  }, [status])

  useEffect(() => {
    if(!rateInDialog && wrapUpTime !== 0 && status !== RECORD_STATE.WAITING_WRAPUP){
      if(timeLeft === 0)
      {
        stopTimer(); 
        !ndScheduled && dispatch(actionPreviewRecord({process:12, camId:camId, callOutId:callOutId, previewTime:initPreviewTime, callId:0, fMultipleJob: records.length === 1 ? 0 : 1, fReplacementJob: fReplacementJob})) 
        setTimeout(() => {dispatch(incrementDiscardedRegisters())},100);   
        setTimeout(() => {dispatch(removeRecord(callOutId))},200);
      } else if( timeLeft < 3)
      {
        dispatch(hideAlertModal());
      }
    }
  }, [timeLeft])



  const disableBtnSaveDisp=()=>{
     let hasSubDisp = Object.keys(dispositionSelected.SubDisposition).length > 0;
     if(hasSubDisp && subDisposition !== null)
     {
       setDisableBtnSave(false)
     }
     else if(!hasSubDisp)
     {
      setDisableBtnSave(false)
     }else
     setDisableBtnSave(true)
  }
  useEffect(() => {
    dispositionSelected !== null && disableBtnSaveDisp();
  }, [dispositionSelected,subDisposition])
  
 
  useEffect(() => {
  if(response.dispositionList !== null)
  {
    Object.keys(response.dispositionList.Dispositions).length === 0 ? setWithDisposition(false) : setWithDisposition(true), setShowDisposition(true);
  }
  }, [response])
  
  const getDisposition =(data)=>{
    const timeout = sharedData.getRequestTimeout();

    let objectResponse = apiCont.getObjectResponse();

    setShowDisposition(false);
          apiCont.dispositionList(data, objectResponse, timeout);
          objectResponse.onError = function (messageError) {
              setResponse({dispositionError: messageError, dispositionList: null });
          };
          objectResponse.onCatch = function (messageError){
          };
          objectResponse.onSuccess = function (objResponse) {
            setResponse({dispositionError:null, dispositionList: objResponse });
          }
  }
  const setDisposition = (item) =>{
    setSubDisposition(null);
    setDispositionSelected(item);
  }

  const options = (dispositions) => {
    return Object.values(dispositions).sort((a, b) => (a.Description).localeCompare(b.Description)).sort((a, b) => a.Orden - b.Orden);
  }

return (
  <div className='disp-main-container'>
      {!rateInDialog
      &&
       <TimerCountDown
          showInfinite={false}
          showingTimer={true}
          timeToRate={status=== RECORD_STATE.WAITING_WRAPUP ? 0 : wrapUpTime}
          lineWidth={6}
          colorDown={"#FFB427"}
          colorUp={"#BA5D00"}
          size={60}
          fontsize={"one"}
          waitingWrapUp={status=== RECORD_STATE.WAITING_WRAPUP} />

      
      }
      {withDisposition &&<p className="disp-title-RateCall">{language.getText("CallControlcallCalificationtitle")}</p>}
      <div className='disp-container'>
          {withDisposition &&
              <div className='rcsp-disposition-container'>
              {showDisposition && <SearchSelectionAgent options={options(response.dispositionList.Dispositions)} noDefault sort ignoreCase placeholder={language.getText("CallControlCRMxcontrolsselectAnOption")} filterBy={'Description'} onSelected={item => setDisposition(item) } disabled={status=== RECORD_STATE.WAITING_WRAPUP}/> }
              {showSubDisposition && <SearchSelectionAgent noDefault sort ignoreCase options={options(dispositionSelected.SubDisposition)}  placeholder={language.getText("CallControlCRMxcontrolsselectAnOption")} filterBy={'Description'} onSelected={item =>  setSubDisposition(item)} disabled={status=== RECORD_STATE.WAITING_WRAPUP}/> }
              {showCanReprogram &&
                <div className="disp-rescheduleWindow">
                  <SelectReprogramPhone
                    numbers={response.dispositionList.Numbers}
                    setPhoneReprogram={setPhoneReprogram}
                    phoneCall={phoneToCall}
                    />
                  <DatePicker
                    setDateReprogram={setDateReprogram}
                    callbackDays={response.dispositionList.CallbackDays}/>
                </div>
              }
              {withDisposition &&<div className={`disp-btn-container`}> <AgentButton type='primary'color={'blue'} disabled={disableBtnSave} onClick={endWraUpWithDisp}>{language.getText("GUIPreviewbtnSave")}</AgentButton></div>}
              </div>
          }
        {!rateInDialog && (!withDisposition && <div className={`disp-btn-container ${!withDisposition ? 'withOutDisposition' :''}`}> <AgentButton type='primary'color={'yellow'} disabled={disableBtnSave} onClick={endWraUpWithoutDisp}>{language.getText("CallControlcallCalificationfinishWrapup")}</AgentButton></div>)}
        
      </div>
  </div>
)
}
export default Dispositions


// WEBPACK FOOTER //
// ./src/components/workSpace/Dispositions.jsx